module.exports = __webpack_public_path__ + "static/media/Wireshark_Logo.svg.d0409607.png";